export default __webpack_public_path__ + "static/media/api.62f64b5c.jpg";